export default "__VITE_ASSET__w4S1lNtS__"